import { Plan } from './components/Plan';
import withTableController from '../../../../../HOC/tableController/withTableControllerForAdminPlanning';

const Plan23 = withTableController(({ planing, state }) => (
  <Plan planing={planing} state={state} />
));

export default Plan23;
